import React from 'react';
import InfoContainerMD from '../../core/infoContainerMD';
import { districtsHeadings } from '../configs/districtsInfoConfig';
import ParentAccessPanel from './parentAccessPanel';
import DemographicsPanel from './demographicsPanel';
import SchedulesPanel from './schedulesPanel';
import SisPanel from './sisPanel';
import SecurityPanel from './securityPanel';


const DistrictInformationTab = ({data, handleOpen, updating, setUpdating}) => {
    return (
        <>
        <InfoContainerMD
            config={districtsHeadings}
            infoData={data}
            incidentData={true}
            handleOpen={handleOpen}
            updating={updating}
            setUpdating={setUpdating}
            type={"districts"}
        />
        <SecurityPanel data={data} />
        <ParentAccessPanel data={data} />
        <DemographicsPanel data={data} />
        <SchedulesPanel data={data} />
        <SisPanel data={data} />
        </>
    );
};

export default DistrictInformationTab;